const Lock = ({ stroke = "currentColor", ...p }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
    {...p}
  >
    <rect
      x="2.5"
      y="7"
      width="11"
      height="7"
      rx="1.4"
      stroke={stroke}
      strokeWidth="1.4"
    />
    <path
      d="M5 7V5a3 3 0 0 1 6 0v2"
      stroke={stroke}
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <circle cx="8" cy="10.5" r="1" fill={stroke} />
  </svg>
);

export default Lock;
